export default __webpack_public_path__ + "static/media/logo_icon_white.37c48315.svg";